core.factory('preventTemplateCacheInterceptor', [
    function () {

        return {
            request: function(request) {
                if (request.url.indexOf('.html') !== -1 && request.url.indexOf('/application/') !== -1) {
                    request.url = request.url + '?t=' + Date.now();
                }
                return request;
            }
        };
    }
]);
